import React, { useEffect } from 'react';
import './SplashScreen.css';
import logo from '../../Assets/splashScreen-image.jpg';

const SplashScreen = ({ onFinish }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onFinish(); // calling the parent function after 3 seconds
        }, 3000);
        return () => clearTimeout(timer);
    }, [onFinish]);

    return (
        <div className="splash-screen">
            <img src={logo} alt="App Logo" className="splash-logo" />
            <h2 className="splash-title">Welcome to Exam App</h2>
        </div>
    );
};

export default SplashScreen;
